import React from 'react';
import bindAll from 'lodash.bindall';
import { Box } from "@chakra-ui/layout";
import IconButton from '../components/icon-button/icon-button';
import './connection.css';
import usbIcon from './assets/icon--usb.svg';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
// import VM from 'scratch-vm';
// import classNames from 'classnames';
// import {openConnectionModal} from '../reducers/modals.js';
import { setConnectState, setConnectionMode } from '../store/connect-state'
import { setDisconnectModal } from '../store/modals'
import { ProjectActions } from "../project/project-actions";
// import { useProjectActions } from '../project/project-hooks'
import {
    ConnectionAction
  } from "../device/device";

const projectActions = new ProjectActions();
// const actions = useProjectActions()

class UsbBtn extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['handleConnect']);
    }

    componentDidMount () {
        this.menuButtonRef = React.createRef();
    }

    handleConnect = async () => {
        if (!this.props.isConnected) {
            this.props.setConnectionMode('usb');
            window.peripheral.usb('0x303a')
        } else {
            this.props.setDisconnectModal(true)
        }
    }
    // handleConnect () {
        // if (this.props.vm.getPeripheralIsConnected('Nous')) {
        //     this.props.onShowExtensionAlert('Nous');
        // } else {
        //     this.props.vm.connectUsbPeripheral('Nous', '0x303a');
        // }
    // }

    render () {
        return (

            <IconButton
                ref={this.menuButtonRef}
                className={!this.props.show ? 'usbButton active' : 'usbButton'}
                // className={classNames(styles.usbButton, {
                //     [styles.active]: !this.props.show
                // })}
                img={usbIcon}
                onClick={this.handleConnect}
            />
        );
    }
}

UsbBtn.propTypes = {
    // vm: PropTypes.instanceOf(VM).isRequired,
    isConnected: PropTypes.bool,
    show: PropTypes.bool,
    onShowExtensionAlert: PropTypes.func
};

const mapStateToProps = state => ({
    isConnected: state.connectStore.isConnected
});

const mapDispatchToProps = dispatch => ({
    setConnectionMode: mode => {
        dispatch(setConnectionMode(mode));
    },
    setDisconnectModal: state => {
        dispatch(setDisconnectModal(state));
    },
    onShowExtensionAlert: data => {
        // dispatch(setConnectionModalExtensionId(data));
        // dispatch(openConnectionModal());
    }
});

export default compose(
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(UsbBtn);
